var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "10px 5px", "background-color": "#003333" } },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 24 }
                },
                [
                  _c("el-avatar", {
                    attrs: {
                      fit: "contain",
                      size: 130,
                      src: _vm.propsData.agentImageUrl1
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "agent-name" }, [
                    _vm._v(_vm._s(_vm.propsData.agentFirstName1))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "agent-name" }, [
                    _vm._v(_vm._s(_vm.propsData.agentLastName1))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.propsData.agentMobile1
                ? _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("number-reveal", {
                        attrs: {
                          "phone-number": _vm.getMobileNumber(
                            _vm.propsData.agentCountryCode1,
                            _vm.propsData.agentMobile1
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "meet-agent-title" }, [
                    _vm._v("Meet your agent")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-col",
                {
                  staticClass: "agent-desc",
                  staticStyle: { "margin-top": "1%" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "agent-desc-wrap",
                      class: { "limited-lines": !_vm.showAgent1FullText }
                    },
                    [_vm._v(_vm._s(_vm.propsData.agentImageBio1))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "link-style",
                      on: { click: _vm.readMoreToggle }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.showAgent1FullText ? "Read Less" : "Read More"
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "agent-desc",
                  staticStyle: { "margin-top": "1%" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "agent-desc-wrap" }, [
                    _vm._v(_vm._s(_vm.propsData.companyRla))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.propsData.agentFirstName2
        ? _c(
            "el-col",
            { staticStyle: { "margin-top": "10px" }, attrs: { span: 24 } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-avatar", {
                        attrs: {
                          fit: "contain",
                          size: 130,
                          src: _vm.propsData.agentImageUrl2
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "agent-name" }, [
                        _vm._v(_vm._s(_vm.propsData.agentFirstName2))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "agent-name" }, [
                        _vm._v(_vm._s(_vm.propsData.agentLastName2))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.propsData.agentMobile2
                    ? _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c("number-reveal", {
                            attrs: {
                              "phone-number": _vm.getMobileNumber(
                                _vm.propsData.agentCountryCode2,
                                _vm.propsData.agentMobile2
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-start"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "meet-agent-title" }, [
                        _vm._v("Meet your agent")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "agent-desc",
                      staticStyle: { "margin-top": "1%" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "agent-desc-wrap",
                          class: { "limited-lines": !_vm.showAgent2FullText }
                        },
                        [_vm._v(_vm._s(_vm.propsData.agentImageBio2))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-link",
                        {
                          staticClass: "link-style",
                          on: { click: _vm.readMoreToggle }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.showAgent2FullText ? "Read Less" : "Read More"
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticClass: "agent-desc",
                      staticStyle: { "margin-top": "1%" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "agent-desc-wrap" }, [
                        _vm._v(_vm._s(_vm.propsData.companyRla))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b2df88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b2df88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/meetAgent.vue
// module id = null
// module chunks = 